import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css'
import './assets/css/global.scss'
import service from './utils/request'
import '@/permission.js'
import 'video.js/dist/video-js.css'
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iView);

Vue.use(ElementUI)

Vue.config.productionTip = false
// 引入cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

window.$cookies.config('2d')
import './assets/stylus/index.styl'
Vue.prototype.$axios = service


// 注册编辑锁管理工具为全局属性
import editLockManager from '@/utils/editLock'
Vue.prototype.$editLock = editLockManager

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
